import { ECodeType } from '../../store/ducks/user/types';

export const EndpointsMvp = {
  //CART
  CREATE_CART: '/commerce/carts',
  MINIMUN_ORDER: (cartId: string) =>
    `/commerce/carts/${cartId}/minimun_sales_order`,
  CART: (cartId: string) => `/commerce/carts/${cartId}`,
  GET_ITEMS: (cartId: string) => `/commerce/carts/${cartId}/items`,
  CART_ITEM_QUANTITY: (cartId: string) =>
    `/commerce/carts/${cartId}/items/count`,
  ADD_ITEM: (cartId: string) => `/commerce/carts/${cartId}/items`,
  ADD_ITEM_BULK: (cartId: string) => `/commerce/carts/${cartId}/items/bulk`,
  UPDATE_ITEM: (cartId: string, itemId: number) =>
    `/commerce/carts/${cartId}/items/${itemId}`,
  DELETE_ITEM: (cartId: string, itemId: number) =>
    `/commerce/carts/${cartId}/items/${itemId}`,
  DELETE_ITEMS: (cartId: string) => `/commerce/carts/${cartId}/items`,
  SEARCH_PRODUCTS: (products: string[]) => {
    const productsTrim = encodeURIComponent(products.join(','));
    return `/commerce/products?searchCriteria[filter_groups][0][filters][0][field]=sku&searchCriteria[filter_groups][0][filters][0][value]=${productsTrim}&searchCriteria[filter_groups][0][filters][0][conditionType]=in`;
  },

  // PRODUCTS
  SEARCH_PRODUCTS_FOR_CUSTOMER: '/search/_sql',
  FETCH_PRODUCT_DETAILS: (sku: string, soldTo: string, shipTo: string) =>
    `/commerce/products/${sku}?soldTo=${soldTo}&shipTo=${shipTo}`,
  FETCH_PURCHASE_HISTORIC: (customer: string, hidePrice: boolean) =>
    `/entry-order/last-orders?customer=${customer}&hidePrice=${hidePrice}`,
  PRODUCT_PRICING: '/product-pricing',
  PRODUCTS_SORT: '/commerce/products-sort',
  PRODUCTS_SEARCH: '/search/products-search',
  PRODUCTS_TYPES: '/search/products-type',
  PRODUCTS_PRICING: '/product-pricing',
  CATEGORIES_LIST: (field: string, value: string, conditionType: string) =>
    `/categories/list?searchCriteria[filterGroups][0][filters][0][field]=${field}&searchCriteria[filterGroups][0][filters][0][value]=${value}&searchCriteria[filterGroups][0][filters][0][conditionType]=${conditionType}`,
  PRODUCTS_SEARCH_SKU_OR_INTERNAL_COD: '/search/products-search',
  SEARCH_MULT_PRODUCTS: (
    products: string[],
    codeType: ECodeType,
    customer: string,
    pageSize: number,
    currentPage: number,
    codActivityItems: string[]
  ) => {
    const productsTrim = encodeURIComponent(products.join(','));
    return `/commerce/products?searchCriteria[filter_groups][0][filters][0][field]=sap_cod_setor_atividade&searchCriteria[filter_groups][0][filters][0][value]=${codActivityItems}&searchCriteria[filter_groups][0][filters][0][conditionType]=in&searchCriteria[filter_groups][2][filters][0][field]=${codeType}&searchCriteria[filter_groups][2][filters][0][value]=${productsTrim}&searchCriteria[filter_groups][2][filters][0][conditionType]=in&searchCriteria[currentPage]=${currentPage}&searchCriteria[pageSize]=${pageSize}&soldTo=${customer}&shipTo=${customer}`;
  },
  CUSTOMER_PRODUCTS_INDEX: '/search/customer-products-index'
};

export enum CookiesKey {
  ACCESS_TOKEN = '@access_token',
  SSO_ACCESS = '@sso-access',
  CART_ID = '@cart',
  EMITTER_ID = '@emitter',
  ORDER_CONTINUOS = '@ordercontinuos',
  AUTHORIZATION_TOKEN = '@authorization-token',
  PROFILE_ACCESS_TOKEN = '@Profile-Access-Token',
  CORRELATION_ID = '@x-correlation-id'
}
